import React from "react";

import { type RouteConfig } from "@/routes/routes";
import { SETTINGS_INDEX, STUDIO } from "@/shared/constants/routes";

const StudioIndex = React.lazy(
  () => import("@/features/studio/presentation/pages/studio-index/StudioIndex")
);

const SettingsIndex = React.lazy(
  () =>
    import("@/features/studio/presentation/pages/settings-index/SettingsIndex")
);

export const routes: RouteConfig[] = [
  {
    path: STUDIO,
    element: <StudioIndex />,
    isPrivate: true
  },
  {
    path: SETTINGS_INDEX,
    element: <SettingsIndex />,
    isPrivate: true
  }
];
